import React, { useCallback } from 'react';
import apiService from '../../services/apiService';
import { useToast } from '../ToastProvider';
import { useI18n } from '../../utils/i18n';

// #604: „Gebucht“ umschalten, nur aus den Rechtsklick-Menüs der drei Kalender.
// An den Ticketkarten (TicketContextMenu) gibt es den Punkt bewusst nicht:
// Gebucht wird ein Termin, und ein Ticket ohne Termin hat nichts zu buchen
// (Feedback 56, #617). Der Server setzt dabei die Outlook-Kategorie „Gebucht“
// an den Terminen des Tickets.

/** Darf der Punkt erscheinen? Abgeschlossene und archivierte Tickets nicht. */
export function gebuchtUmschaltbar(ticket) {
  return !!ticket && ticket.status !== 'abgeschlossen' && !ticket.isArchived;
}

/**
 * Hook: `umschalten(ticket)` speichert das Gegenteil des aktuellen Stands und
 * ruft danach `nachher(neuerWert)` (z. B. Kalender neu laden). Gesplittete
 * Blöcke tragen die Ticket-ID in `originalTicketId`.
 */
export function useGebuchtUmschalten(nachher) {
  const { pushToast } = useToast();
  const { t } = useI18n();
  return useCallback(async (ticket) => {
    if (!gebuchtUmschaltbar(ticket)) return;
    const neu = !ticket.isGebucht;
    try {
      await apiService.updateTicket(ticket.originalTicketId || ticket.id, { isGebucht: neu });
      pushToast({
        message: neu
          ? t('contextMenu.bookedSet', 'Als gebucht markiert.')
          : t('contextMenu.bookedRemoved', 'Markierung „Gebucht“ entfernt.'),
        type: 'success'
      });
      if (nachher) await nachher(neu);
    } catch (error) {
      console.error('Error toggling isGebucht:', error);
      pushToast({ message: error?.response?.data?.error || t('contextMenu.bookedError', '„Gebucht“ konnte nicht gespeichert werden.'), type: 'error' });
    }
  }, [nachher, pushToast, t]);
}

/** Menüpunkt im Stil der Kalender-Kontextmenüs. */
export function GebuchtMenuePunkt({ ticket, onClick }) {
  const { t } = useI18n();
  if (!gebuchtUmschaltbar(ticket)) return null;
  return (
    <div
      className="context-menu-item gebucht-menuepunkt"
      role="menuitem"
      onClick={onClick}
    >
      <span className="gebucht-farbfeld" aria-hidden="true" />
      {ticket.isGebucht
        ? t('contextMenu.unmarkBooked', 'Nicht mehr gebucht')
        : t('contextMenu.markBooked', 'Als gebucht markieren')}
    </div>
  );
}
